import { createSelector } from '@ngrx/store';
import { GetSurveysParams } from '@ps/survey-utils';

import { surveyFeature } from '../survey.feature';

const { selectSurveyState, selectQuery, selectChildren } = surveyFeature;

export { selectSurveyState };

export const selectLoading = createSelector(
  selectQuery,
  ({ loadStatus }) => loadStatus !== 'idle',
);

export const selectSlowLoading = createSelector(
  selectQuery,
  ({ loadStatus }) => loadStatus === 'slow-loading',
);
export const selectError = createSelector(selectQuery, ({ error }) => error);

// ── Query selectors ───────────────────────────────────────────────────────────

export const selectSurveys = createSelector(
  selectQuery,
  ({ surveys }) => surveys,
);

export const selectSurveyIds = createSelector(
  selectSurveys,
  (surveys): number[] => surveys.map((survey) => survey.id),
);
export const selectCounts = createSelector(selectQuery, ({ counts }) => counts);

export const selectContext = createSelector(
  selectQuery,
  ({ context }) => context,
);

export const selectActiveTabId = createSelector(
  selectQuery,
  ({ activeTabId }) => activeTabId,
);

export const selectFilters = createSelector(
  selectQuery,
  ({ filters }) => filters,
);
export const selectSort = createSelector(selectQuery, ({ sort }) => sort);

export const selectPagination = createSelector(
  selectQuery,
  ({ pagination }) => pagination,
);
export const selectPage = createSelector(selectPagination, ({ page }) => page);
export const selectHasMore = createSelector(
  selectPagination,
  ({ hasMore }) => hasMore,
);

export const selectQueryParams = createSelector(
  selectQuery,
  ({ filters, context, pagination, sort }): GetSurveysParams => ({
    filters,
    context,
    pagination,
    sort,
  }),
);

export const selectLoadingSnapshot = createSelector(
  selectQuery,
  ({ loadingSnapshot }) => loadingSnapshot,
);

// ── Children selectors ───────────────────────────────────────────────────────

export const selectChildSurveys = createSelector(
  selectChildren,
  ({ childSurveys }) => childSurveys,
);
export const selectChildSurveysCache = createSelector(
  selectChildren,
  ({ childSurveysCachedAt, childSurveys }) => ({
    childSurveys,
    cachedAt: childSurveysCachedAt,
  }),
);
export const selectChildSurveyErrors = createSelector(
  selectChildren,
  ({ childSurveyErrors }) => childSurveyErrors,
);
